var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-row",
    [
      _c(
        "w-col",
        { attrs: { xs: "12", xl: "6" } },
        [
          _c(
            "w-card",
            [
              _c("w-card-title", [
                _vm._v(_vm._s(_vm.$ct("ubl-settings-email"))),
              ]),
              _c(
                "w-card-content",
                [
                  _c(
                    "w-row",
                    [
                      _c(
                        "w-col",
                        [
                          _c("w-info", {
                            staticClass: "mts",
                            attrs: {
                              "ico-lib": "fas",
                              tiny: "",
                              text: _vm.$ct("bookkeeper-email-sales-info"),
                            },
                          }),
                          _c("w-input", {
                            attrs: {
                              label: _vm.$ct("bookkeeper-email"),
                              fancy: "",
                            },
                            model: {
                              value: _vm.bookkeeperEmailSales,
                              callback: function ($$v) {
                                _vm.bookkeeperEmailSales = $$v
                              },
                              expression: "bookkeeperEmailSales",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "w-row",
                    [
                      _c(
                        "w-col",
                        [
                          _c("w-multi-select", {
                            attrs: {
                              label: _vm.$ct("bookkeeper-attachments-sales"),
                              items: _vm.saleOptions,
                              fancy: "",
                            },
                            model: {
                              value: _vm.bookkeeperAttachmentsSales,
                              callback: function ($$v) {
                                _vm.bookkeeperAttachmentsSales = $$v
                              },
                              expression: "bookkeeperAttachmentsSales",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "w-row",
                    [
                      _c(
                        "w-col",
                        [
                          _c("w-checkbox", {
                            attrs: {
                              label: _vm.$ct(
                                "auto-send-sales-to-bookkeeper-daily"
                              ),
                              disabled:
                                _vm.bookkeeperAttachmentsSales.length == 0,
                              "auto-turn-off-on-disable": "",
                            },
                            model: {
                              value: _vm.autoSendToBookkeeperSettings.SendSales,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.autoSendToBookkeeperSettings,
                                  "SendSales",
                                  $$v
                                )
                              },
                              expression:
                                "autoSendToBookkeeperSettings.SendSales",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("w-row", [_c("w-col", [_c("w-divider")], 1)], 1),
                  _c(
                    "w-row",
                    [
                      _c(
                        "w-col",
                        [
                          _c("w-info", {
                            staticClass: "mts",
                            attrs: {
                              "ico-lib": "fas",
                              tiny: "",
                              text: _vm.$ct("bookkeeper-email-purchases-info"),
                            },
                          }),
                          _c("w-input", {
                            attrs: {
                              label: _vm.$ct("bookkeeper-email-purchases"),
                              fancy: "",
                            },
                            model: {
                              value: _vm.bookkeeperEmailPurchases,
                              callback: function ($$v) {
                                _vm.bookkeeperEmailPurchases = $$v
                              },
                              expression: "bookkeeperEmailPurchases",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "w-row",
                    [
                      _c(
                        "w-col",
                        [
                          _c("w-multi-select", {
                            attrs: {
                              label: _vm.$ct(
                                "bookkeeper-attachments-purchases"
                              ),
                              items: _vm.purchaseOptions,
                              fancy: "",
                            },
                            model: {
                              value: _vm.bookkeeperAttachmentsPurchases,
                              callback: function ($$v) {
                                _vm.bookkeeperAttachmentsPurchases = $$v
                              },
                              expression: "bookkeeperAttachmentsPurchases",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "w-row",
                    [
                      _c(
                        "w-col",
                        [
                          _c("w-checkbox", {
                            attrs: {
                              label: _vm.$ct(
                                "auto-send-purchases-to-bookkeeper-daily"
                              ),
                              disabled:
                                _vm.bookkeeperAttachmentsPurchases.length == 0,
                              "auto-turn-off-on-disable": "",
                            },
                            model: {
                              value:
                                _vm.autoSendToBookkeeperSettings.SendPurchases,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.autoSendToBookkeeperSettings,
                                  "SendPurchases",
                                  $$v
                                )
                              },
                              expression:
                                "autoSendToBookkeeperSettings.SendPurchases",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("w-row", [_c("w-col", [_c("w-divider")], 1)], 1),
                  _c(
                    "w-row",
                    [
                      _c(
                        "w-col",
                        [
                          _c("w-info", {
                            staticClass: "mts",
                            attrs: {
                              "ico-lib": "fas",
                              tiny: "",
                              text: _vm.$ct(
                                "bookkeeper-email-incomming-peppol-orders-info"
                              ),
                            },
                          }),
                          _c("w-input", {
                            attrs: {
                              label: _vm.$ct(
                                "bookkeeper-email-incomming-peppol-orders"
                              ),
                              fancy: "",
                            },
                            model: {
                              value: _vm.bookkeeperEmailIncommingPeppolOrders,
                              callback: function ($$v) {
                                _vm.bookkeeperEmailIncommingPeppolOrders = $$v
                              },
                              expression:
                                "bookkeeperEmailIncommingPeppolOrders",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "w-row",
                    [
                      _c(
                        "w-col",
                        [
                          _c("w-multi-select", {
                            attrs: {
                              label: _vm.$ct(
                                "bookkeeper-attachments-incomming-peppol-orders"
                              ),
                              items: _vm.incommingPeppolOrderOptions,
                              fancy: "",
                            },
                            model: {
                              value:
                                _vm.bookkeeperAttachmentsIncommingPeppolOrders,
                              callback: function ($$v) {
                                _vm.bookkeeperAttachmentsIncommingPeppolOrders =
                                  $$v
                              },
                              expression:
                                "bookkeeperAttachmentsIncommingPeppolOrders",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "w-row",
                    [
                      _c(
                        "w-col",
                        [
                          _c("w-checkbox", {
                            attrs: {
                              disabled:
                                _vm.bookkeeperAttachmentsIncommingPeppolOrders
                                  .length == 0,
                              label: _vm.$ct(
                                "auto-send-incomming-peppol-orders-to-bookkeeper-daily"
                              ),
                              "auto-turn-off-on-disable": "",
                            },
                            model: {
                              value:
                                _vm.autoSendToBookkeeperSettings
                                  .SendIncommingPeppolOrders,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.autoSendToBookkeeperSettings,
                                  "SendIncommingPeppolOrders",
                                  $$v
                                )
                              },
                              expression:
                                "autoSendToBookkeeperSettings.SendIncommingPeppolOrders",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "w-col",
                        [
                          _c("w-date-picker", {
                            attrs: {
                              fancy: "",
                              disabled:
                                !_vm.autoSendToBookkeeperSettings
                                  .SendIncommingPeppolOrders,
                              nullable: "",
                              label: _vm.$ct(
                                "auto-send-incomming-peppol-orders-to-bookkeeper-daily-from-date"
                              ),
                            },
                            model: {
                              value:
                                _vm.autoSendToBookkeeperSettings
                                  .SendIncommingPeppolOrdersFromDate,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.autoSendToBookkeeperSettings,
                                  "SendIncommingPeppolOrdersFromDate",
                                  $$v
                                )
                              },
                              expression:
                                "autoSendToBookkeeperSettings.SendIncommingPeppolOrdersFromDate",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("w-row", [_c("w-col", [_c("w-divider")], 1)], 1),
                  _c(
                    "w-row",
                    [
                      _c(
                        "w-col",
                        [
                          _c("w-info", {
                            staticClass: "mts",
                            attrs: {
                              "ico-lib": "fas",
                              tiny: "",
                              text: _vm.$ct(
                                "bookkeeper-email-incomming-email-documents-info"
                              ),
                            },
                          }),
                          _c("w-input", {
                            attrs: {
                              label: _vm.$ct(
                                "bookkeeper-email-incomming-email-documents"
                              ),
                              fancy: "",
                            },
                            model: {
                              value: _vm.bookkeeperEmailIncommingEmailDocuments,
                              callback: function ($$v) {
                                _vm.bookkeeperEmailIncommingEmailDocuments = $$v
                              },
                              expression:
                                "bookkeeperEmailIncommingEmailDocuments",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "w-row",
                    [
                      _c(
                        "w-col",
                        [
                          _c("w-multi-select", {
                            attrs: {
                              label: _vm.$ct(
                                "bookkeeper-attachments-incomming-email-documents"
                              ),
                              items: _vm.incommingPeppolOrderOptions,
                              fancy: "",
                            },
                            model: {
                              value:
                                _vm.bookkeeperAttachmentsIncommingEmailDocuments,
                              callback: function ($$v) {
                                _vm.bookkeeperAttachmentsIncommingEmailDocuments =
                                  $$v
                              },
                              expression:
                                "bookkeeperAttachmentsIncommingEmailDocuments",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "w-row",
                    [
                      _c(
                        "w-col",
                        [
                          _c("w-checkbox", {
                            attrs: {
                              disabled:
                                _vm.bookkeeperAttachmentsIncommingEmailDocuments
                                  .length == 0,
                              label: _vm.$ct(
                                "auto-send-incomming-email-documents-to-bookkeeper-daily"
                              ),
                              "auto-turn-off-on-disable": "",
                            },
                            model: {
                              value:
                                _vm.autoSendToBookkeeperSettings
                                  .SendIncommingEmailDocuments,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.autoSendToBookkeeperSettings,
                                  "SendIncommingEmailDocuments",
                                  $$v
                                )
                              },
                              expression:
                                "autoSendToBookkeeperSettings.SendIncommingEmailDocuments",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "w-col",
                        [
                          _c("w-date-picker", {
                            attrs: {
                              fancy: "",
                              disabled:
                                !_vm.autoSendToBookkeeperSettings
                                  .SendIncommingEmailDocuments,
                              nullable: "",
                              label: _vm.$ct(
                                "auto-send-incomming-email-documents-to-bookkeeper-daily-from-date"
                              ),
                            },
                            model: {
                              value:
                                _vm.autoSendToBookkeeperSettings
                                  .SendIncommingEmailDocumentsFromDate,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.autoSendToBookkeeperSettings,
                                  "SendIncommingEmailDocumentsFromDate",
                                  $$v
                                )
                              },
                              expression:
                                "autoSendToBookkeeperSettings.SendIncommingEmailDocumentsFromDate",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "w-row",
                    [
                      _c(
                        "w-col",
                        [
                          _c("w-info", {
                            staticClass: "mts",
                            attrs: {
                              "ico-lib": "fas",
                              tiny: "",
                              text: _vm.$ct("bookkeeper-email-archives-info"),
                            },
                          }),
                          _c("w-input", {
                            attrs: {
                              label: _vm.$ct("bookkeeper-email-archives"),
                              fancy: "",
                            },
                            model: {
                              value: _vm.config.BookkeeperEmailArchives,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.config,
                                  "BookkeeperEmailArchives",
                                  $$v
                                )
                              },
                              expression: "config.BookkeeperEmailArchives",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "w-card-actions",
                [
                  _c("w-spacer"),
                  _vm.$wf.isMdUp
                    ? _c(
                        "w-button",
                        {
                          attrs: { icon: "save" },
                          on: {
                            click: function ($event) {
                              return _vm.save()
                            },
                          },
                        },
                        [_vm._v(" " + _vm._s(_vm.$t("common.save")) + " ")]
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }